import { toast } from "sonner";

import { instance, pathname } from "store/reducers/ActionCreators";

export default async function Success(text: string) {
    toast.success(text, {
        duration: Infinity,
        style: {
            background: "white",
            border: "1px solid #52c41a",
            borderRadius: "4px",
            boxShadow:
                "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
            padding: "12px 16px",
            fontSize: "14px",
            color: "rgba(0, 0, 0, 0.88)",
        },
    });

    try {
        await instance.post(pathname + "/api/web_alerts", {
            text,
            level: "success",
        });
    } catch (error) {
        console.error("Ошибка отправки web alert:", error);
    }
}
